import { Link, navigate } from 'gatsby';
import Img from 'gatsby-image';
import React, { useEffect, useState } from 'react';

export default function LinkTitle({ title, img, urlPath, setIsHover }) {
  const apiToken =
    'pk.eyJ1IjoibG91aXNlcGljb3QiLCJhIjoiY2t2YzNwbW1oMGhoZjJ3bzhpaWZxazJ3cSJ9.jcupwDKk_QBW9WMbQhtCcA';

  const [place, setPlace] = useState('');

  useEffect(() => {
    // get data from GitHub api
    if (title.lieux) {
      fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${title.lieux.lng},${title.lieux.lat}.json?types=place&access_token=${apiToken}`
      )
        .then((response) => response.json()) // parse JSON from request
        .then((resultData) => {
          setPlace(resultData.features[0].text);
        });
    }
  }, []);

  return (
    <div>
      {img ? (
        <Link
          to={`/${urlPath}/${title.slug.current}`}
          className={`${urlPath} ${title.slug.current} link-list imgLink`}
          onMouseOver={() => setIsHover(title.slug.current)}
          onMouseOut={() => setIsHover(false)}
          onTouchEnd={() => {
            navigate(`/${urlPath}/${title.slug.current}`);
          }}
        >
          <li>
            <Img
              fluid={title.vignette.asset.fluid}
              className="vignette"
              alt={title.name}
            />
          </li>
        </Link>
      ) : (
        <Link
          to={`/${urlPath}/${title.slug.current}`}
          className={`${urlPath} ${title.slug.current} link-list`}
          onMouseOver={() => setIsHover(title.slug.current)}
          onMouseOut={() => setIsHover(false)}
          onTouchEnd={() => {
            navigate(`/${urlPath}/${title.slug.current}`);
          }}
        >
          <li>
            {title.date} {title.name} {place ? `/ ${place}` : ''}
          </li>
        </Link>
      )}
    </div>
  );
}
